import { css } from '@emotion/react'
import { Button, Col, Content, Row, Title } from 'common-components'
import { Space } from 'antd'

// TODO remove this
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Header = function ({ data }) {
  const texts = [
    {
      type: 'tablePageTitle',
      content: 'Mes contributions',
    },
  ]

  return (
    // @ts-ignore
    <Content>
      <Row
        justify={'space-between'}
        align={'middle'}
        css={css`
          margin: 24px 0;
        `}
      >
        <Col>
          <Row justify={'space-between'} gutter={30} align={'middle'}>
            <Col>
              {texts.map((text, index) => {
                if (index === 0) {
                  return (
                    <Space align={'center'}>
                      <Title key={`title-${text.content}-${index}`} style={{ fontSize: 18 }}>
                        {text.content}
                      </Title>
                    </Space>
                  )
                }
                return (
                  <Title key={`title-${text.content}-${index}`} preset={text.type as any}>
                    {text.content}
                  </Title>
                )
              })}
            </Col>
          </Row>
        </Col>
        <Col>
          {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
          <Button iconLeft='FilterLines' onClick={() => {}}>
            Filtrer
          </Button>
        </Col>
      </Row>
    </Content>
  )
}

export default Header
